import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { PositionNotFountError } from "../../domain/errors/position-not-found-error";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Inventory } from "../../domain/models/inventory";
import { LoadExternalInventoryByEan } from "../../domain/usecases/load-external-inventory-by-ean";

import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadExternalInventoryByEan
  implements LoadExternalInventoryByEan
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async load(
    codes: string[],
    branch?: string[]
  ): Promise<
    {
      eanCode: string;
      description: string;
      unit: string;
      amount: number;
      reference: string;
    }[]
  > {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
      params: { codes, branch },
    });

    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.noContent:
        throw new PositionNotFountError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
